document.addEventListener("DOMContentLoaded", async () => {
  const galleryEl = document.getElementById("gallery");
  if (!galleryEl) return;

  const gids = JSON.parse(galleryEl.dataset.gids);

  const query = `
    query getMetaObjects($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Metaobject {
          id
          fields {
            key
            value
            reference {
              __typename
              ... on MediaImage {
                image {
                  url
                  altText
                }
              }
            }
          }
        }
      }
    }
  `;

  try {
    const response = await fetch("/api/2023-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "37eec4f8d70a843091e6f62ac85183cd",
      },
      body: JSON.stringify({
        query,
        variables: { ids: gids },
      }),
    });

    const { data } = await response.json();
    renderGallery(data.nodes, galleryEl);
  } catch (error) {
    console.error("Failed to load gallery items:", error);
  }
});

function renderGallery(nodes, container) {
  nodes.forEach((metaobject) => {
    if (!metaobject) return;

    const fields = {};
    metaobject.fields.forEach((field) => {
      fields[field.key] = field.reference?.image?.url || field.value;
      if (field.key === "alt_text" && field.reference?.image?.altText) {
        fields["alt_text"] = field.reference.image.altText;
      }
    });

    if (fields.image) {
      const wrapper = document.createElement("div");
      wrapper.className = "gallery-item grid__item shape--arch";

      const img = document.createElement("img");
      img.src = fields.image;
      img.alt = fields.alt_text || "Gallery Image";
      // img.width = 267;
      // img.height = 267;
      wrapper.appendChild(img);

      container.appendChild(wrapper);
    }
  });
}
